// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/vercel/path0/src/models/ec/shop';
import model_2 from '/vercel/path0/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'ec.shop', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
